module.exports = __webpack_public_path__ + "img/katarina_bedrooms_14.6ae92889.jpg";